
<template>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span>
            <!-- Left -->
        </span>
        <span class="md:flex hidden items-center">
            <!-- Right -->
        </span>
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    }
}
</script>
